<template>
  <v-app id="empty">
    <v-main>
      <v-container fluid>
        
        <v-row cols="12">  
          <v-col cols="12" class="px-1"> <!-- Links -->
            <v-card class="ma-2">
              <v-card-title>Overview Photo Assignments</v-card-title>
                <v-card-text>
                  <v-data-table 
                    :items="hsfo" 
                    :search="search"
                    :fixed-header="fixedHeader" 
                    :headers="headers" 
                    :height="fixedHeader ? table_height : null"
                    :disable-pagination=true 
                    no-data-text="No assignments to display" 
                    :hide-default-footer="true" 
                  >
                  <template v-slot:top>
                    <v-text-field v-if="searchfield"
                    v-model="search"
                    prepend-icon="mdi-magnify"
                    label="Search through all fields"
                    class="mx-4 searchfield"
                    ></v-text-field>
                  </template>
                  <template v-slot:item="props">
                    <tr>
                    <td class="image-alignment">
                        <div class="image-borders" style="cursor: pointer;">
                            <v-img :src="props.item.photo" width="125px" height="100px"  @click="$router.open('/huis/onHsfoPhotographer/' + props.item.hsfo_encrid)"></v-img>
                        </div>
                    </td>
                    <td @click="$router.open('/huis/onHuis/' + props.item.huis_encrid)" class="td-markup">
                        <div><a> {{ props.item.huis_code }} </a></div>
                    </td>
                    <td>
                      <v-chip :color='statuscolor[props.item.hsfo_status]'>{{ props.item.hsfo_status }}</v-chip>
                    </td>
                    <td>
                        <v-chip :color='priocolor[props.item.hsfo_prio]'>{{ props.item.hsfo_prio }}</v-chip>
                    </td>
                    <td> {{ props.item.huis_postcode }}, {{ props.item.huis_adres }} , {{ props.item.huis_plaats }}</td>
                    <td>  
                      <v-chip class="ma-1" v-for="(hfot, hfotidx) in props.item.hfot" :key="hfotidx" :color='statuscolor_hfot[hfot.hfot_status]'>{{ hfot.hfot_type }}</v-chip>

                    </td>
                    <td> {{ props.item.hsfo_deadline }} </td>
                    <td> {{ props.item.hsfo_inv_dat }} </td>
                    <td> {{ props.item.gebr_naam }} </td>
                    <td>
                      <v-btn color="primary mx-2" @click="viewHsfo(props.item.hsfo_encrid)" small icon><v-icon>mdi-pencil</v-icon></v-btn>
                      <v-btn color="primary" @click="deleteHsfo(props.item.hsfo_encrid)" small icon><v-icon>mdi-trash-can-outline</v-icon></v-btn>
                    </td>
                    </tr> 
                  </template>
                </v-data-table>
              </v-card-text>
             </v-card>
          </v-col>
        </v-row>

       </v-container>
      </v-main>
       <addHsfo ref="addHsfo" @updateData="updateData"></addHsfo>
  <viewHsfo ref="viewHsfo" @updateData="updateData"></viewHsfo>
  <deleteHsfo ref="deleteHsfo" @updateData="updateData"></deleteHsfo>
      <navBar title="Ares - Various" :home="true" type="various" /> 
    </v-app>
  </template>

<script>
  import navBar from "@/components/ui/navbars/navbar.vue";
  import addHsfo from "@/views/huis/hsfo/addHsfo.vue";
  import viewHsfo from "@/views/huis/hsfo/viewHsfo.vue";
  import deleteHsfo from "@/views/huis/hsfo/deleteHsfo.vue";

  export default {
    components: {
      navBar,
      addHsfo,
    viewHsfo,
    deleteHsfo
    },
    data() {
      return {
            localStorageItemStat: 'search.acco.statcodes',
            localStorageItemBedr: 'search.acco.bedrcodes',
            results: false,
            statCodesSelected: [],
            statCodes: [],
            plts_nrKeuzes: [],
            plts_nr: '',
            gebrCodesSelected: [],
            gebrCodes: [],
            bedrCodesSelected: [],
            bedrCodes: [],
            items: [],
            hsfo: [],
            huis_code: '',
            huis_naam: '',
            eign_naam: '',
            eign_email: '',
            partner_acco_id: '',
            param: {},
            searchCityInput: '',
            search: '',
            fixedHeader: true,
            headers: [
              { text: '', value: 'photo', sortable: false, align: 'start' },
              { text: 'Accommodation ID', value: 'huis_code', sortable: false, align: 'start' },
              { text: 'Status', value: 'hsfo_status', sortable: false, align: 'start' },
              { text: 'Priority', value: 'hsfo_prio', sortable: false, align: 'start' },
              { text: 'Acco Address', value: 'huis_adres', sortable: false, align: 'start' },
              { text: 'Tasks', value: 'tasks', sortable: false, align: 'start' },
              { text: 'Deadline', value: 'deadline', sortable: false, align: 'start' },
              { text: 'Date Request', value:'request_date'},
              { text: 'Rental Agent', value:'rental_agent'},
              { text: 'actions', value: 'actions', sortable: false, align: 'center' }
            ],
            table_height:'',
            searchfield: false,
            priocolor: {
              Low: '#D1E2FF',
              Medium: '#74EBE1',
              High: '#DC043B'
            },
            statuscolor: {
              Signedup: '#FAD2FC',
              Readytoshoot: '#FFEAB6',
              Offered: '#D1E2FF',
              Assigned: '#88DBFF',
              Completed: '#9AE095',
              Rejected: '#41454D',
              Onhold: '#FFB68E'
            },
            statuscolor_hfot: {
              Notapplicable: '#DC043B',
              Pending: '#D1E2FF',
              Completed: '#9AE095'
            }
        } 
    },
    methods: {
      
      updateData(data) {
        this[data.field] = data.value;
      },
      addHsfo() {
        this.$refs.addHsfo.open(this.huis_encrid);
      },
      viewHsfo(hsfo_encrid) {
        this.$refs.viewHsfo.open(hsfo_encrid);
      },
      deleteHsfo(hsfo_encrid) {
        this.$refs.deleteHsfo.open(hsfo_encrid);
      },  
      getHsfo() {
        this.results = true;
        this.$axios
        .post("ares/json/ares/huis/searchHsfoSignedUp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchHsfoSignedUp"
          },
          searchHsfoSignedUp: {

          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hsfo = res.data.searchHsfoSignedUp.hsfo;
            if (res.data.color == "warning") {
              this.$store.dispatch('setSnackbar', {
                showing: true,
                text: res.data.text,
                color: res.data.color
              });
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
      }
    },
    mounted() {
      this.getHsfo()

    }
  }
</script> 
  